import React, { PropsWithChildren, useEffect, useRef } from 'react';
import { Switch, SwitchHandle, SwitchProps } from '@progress/kendo-react-inputs';
import { Label } from '@progress/kendo-react-labels';
import { useReadOnlyContext } from '@contexts-clean/read-only-context';

interface ToggleProps extends SwitchProps, PropsWithChildren {
    'data-testid': string;
}

const Toggle = ({ 'data-testid': testId, children, disabled, ...props }: ToggleProps) => {
    const ref = useRef<SwitchHandle>(null);
    const { readOnly } = useReadOnlyContext();

    useEffect(() => {
        ref.current?.element?.setAttribute('data-testid', testId);
    });

    return (
        <div className="k-d-flex k-gap-2 k-align-items-center">
            {children && (
                <Label editorRef={ref} className="k-cursor-pointer k-text-end">
                    {children}
                </Label>
            )}
            <Switch ref={ref} {...props} disabled={disabled || readOnly} size="medium" />
        </div>
    );
};

export default Toggle;
